import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import ScrollMemory from 'react-router-scroll-memory';

import configureStore from 'configureStore';
import configureApi from 'configureApi';
import App from 'components/App/App';

// Import CSS reset and global styles
import 'sanitize.css/sanitize.css';
import 'global-styles';

const store = configureStore();

configureApi(store);

ReactDOM.render(
  <Provider store={store}>
    <Router>
      <div>
        <ScrollMemory />
        <App />
      </div>
    </Router>
  </Provider>,
  document.getElementById('app')
);
